module.exports = __webpack_public_path__ + "static/media/cup-position.1140938e.png";